import React, { useEffect, useState } from "react";
import { Ticket } from "../../../models/Ticket";
import "./style.scss";
import { CALENDAR_SALE, EXERCISE_SCHEDULE } from "../../../routes";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useFacility from "../../../../utils/hooks/useFacility";
import EAButton from "../../shared/Buttons/EAButton";

interface IProps {
  ticket: Ticket;
}
const SelectPassModalFooter: React.FC<IProps> = ({ ticket }: IProps) => {
  const { t } = useTranslation();
  const [bookingOnSchedule, setBookingOnSchedule] = useState<boolean>(true);
  const [showScheduleButton, setShowScheduleButton] = useState<boolean>(false);
  const facilityIds = useFacility();

  // Sprawdzenie specyficznych przypadków obiektów, gdzie używamy innego przycisku
  useEffect(() => {
    // Dla karnetów typu Select (passtype 2 lub 3) domyślnie ukrywamy przycisk
    const isSelectPassType = ticket.passtype === 2 || ticket.passtype === 3;

    // Przycisk jest ukryty dla karnetów typu Select
    setShowScheduleButton(!isSelectPassType);

    // Obsługa specyficznego przypadku (przekierowanie na kalendarz zamiast harmonogramu)
    if (facilityIds === "1212" && ticket.objectId === 112847) {
      setBookingOnSchedule(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds, ticket.passtype]);

  return (
    <React.Fragment>
      <div className="select-pass-modal-footer ">
        <div className="alert alert-action flex-start-center">
          <div className="flex-start-center">
            <span>{t("pozostalo_ci_do_wykorzystania")}</span>

            {ticket.entrances - ticket.exercises.length > 200 ? (
              <b>bez limtu </b>
            ) : (
              <b>{ticket.entrances - ticket.exercises.length}</b>
            )}

            <span> {t("zapisow")}. </span>
          </div>

          {showScheduleButton &&
            (bookingOnSchedule ? (
              <Link className="button text small padding-zero button-text-gray" to={EXERCISE_SCHEDULE}>
                <EAButton title={t("przejdz_do_harmonogramu_aby_sie_zapisac")} variant="text" />
              </Link>
            ) : (
              <Link className="button text small padding-zero button-text-gray" to={CALENDAR_SALE}>
                <EAButton title={t("przejdz_do_kalendarza_aby_sie_zapisac")} variant="text" />
              </Link>
            ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default SelectPassModalFooter;
